
export default function AboutHead() {
  return (
    <>
    <section className="aboutpage-head">
        <div className="container">
            <div className="row align-items-center">  

                <div className="col-lg-6 col-sm-6">
                    {/* <span className="sub-tittle">About Us</span> */}
                    <h2 className="heading">We find inspiration in materials, finishes, and craftsmanship to create iconic and enduring interiors.</h2>
                </div>

                <div className="col-lg-6 col-sm-6">
                    <img src="/image/aboutimage.webp" loading="lazy" className="img-responsive wow animate__animated animate__fadeInRight" data-wow-duration="1.1s" data-wow-delay="0.2s" alt="about"/>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
